/* Mode Siemers - Mengenvorteil. Haelt jeden Fortschrittsbalken aktuell,
   egal ob das Theme den Warenkorb per XHR oder per fetch nachlaedt. */
(function(){
  var TIERS=[{q:2,p:10},{q:3,p:15},{q:4,p:20}], MAX=4, last=-1, busy=false;

  function paint(count){
    var boxes=document.querySelectorAll('[data-ms-prog]');
    if(!boxes.length) return;
    var reached=0,next=null,i;
    for(i=0;i<TIERS.length;i++){ if(count>=TIERS[i].q) reached=TIERS[i].p; }
    for(i=0;i<TIERS.length;i++){ if(count<TIERS[i].q){ next=TIERS[i]; break; } }
    var msg;
    if(count<1){ msg='Ab <b>2 Artikeln</b> sparen Sie <b>10 %</b>'; }
    else if(next){ msg='Noch <b>'+(next.q-count)+' Artikel</b> bis <b>'+next.p+' % Rabatt</b>'+(reached?' – aktuell '+reached+' % gesichert':''); }
    else { msg='Bester Mengenvorteil erreicht: <b>'+reached+' % Rabatt</b> auf Ihre Bestellung'; }
    var pct=Math.min(100,(count/MAX)*100);
    for(var b=0;b<boxes.length;b++){
      var box=boxes[b];
      box.removeAttribute('hidden');
      var m=box.querySelector('[data-ms-prog-msg]'), f=box.querySelector('[data-ms-prog-fill]');
      if(m) m.innerHTML=msg;
      if(f) f.style.width=pct+'%';
      var mk=box.querySelectorAll('[data-ms-mark]');
      for(var k=0;k<mk.length;k++){
        var need=parseInt(mk[k].getAttribute('data-ms-mark'),10);
        if(count>=need) mk[k].classList.add('is-on'); else mk[k].classList.remove('is-on');
      }
    }
    var hc=document.querySelectorAll('[data-ms-count],[data-ms-headcount]');
    for(var h=0;h<hc.length;h++){
      hc[h].textContent = count>0 ? (hc[h].hasAttribute('data-ms-count') ? '('+count+')' : count+' Artikel') : '';
    }
  }

  function pull(){
    if(busy) return; busy=true;
    var x=new XMLHttpRequest();
    x.open('GET','/cart.js?msq='+Date.now(),true);
    x.onload=function(){
      busy=false;
      try{ var c=JSON.parse(x.responseText).item_count||0; if(c!==last){ last=c; paint(c); } }catch(e){}
    };
    x.onerror=function(){ busy=false; };
    x.send();
  }
  function soon(d){ setTimeout(pull, d||150); }

  /* Theme-Requests abfangen: XHR */
  var oOpen=XMLHttpRequest.prototype.open, oSend=XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open=function(m,u){ this.__msu=(u||'')+''; return oOpen.apply(this,arguments); };
  XMLHttpRequest.prototype.send=function(){
    var u=this.__msu||'';
    if(u.indexOf('/cart')>-1 && u.indexOf('msq=')===-1){
      try{ this.addEventListener('load',function(){ soon(200); }); }catch(e){}
    }
    return oSend.apply(this,arguments);
  };

  /* Theme-Requests abfangen: fetch */
  if(window.fetch){
    var oF=window.fetch;
    window.fetch=function(){
      var p=oF.apply(this,arguments);
      try{
        var a=arguments[0], u=typeof a==='string'?a:((a&&a.url)||'');
        if(u.indexOf('/cart')>-1 && u.indexOf('msq=')===-1 && p && p.then) p.then(function(){ soon(200); });
      }catch(e){}
      return p;
    };
  }

  /* Sichtbare Aenderungen beobachten */
  function watch(){
    if(!window.MutationObserver) return;
    var obs=new MutationObserver(function(){ soon(120); });
    var d=document.getElementById('CartDrawer');
    if(d) obs.observe(d,{childList:true,subtree:true,characterData:true});
    var bubbles=document.querySelectorAll('.cart-link__bubble, .site-header__cart-count, [data-cart-count]');
    for(var i=0;i<bubbles.length;i++) obs.observe(bubbles[i],{childList:true,subtree:true,characterData:true,attributes:true});
  }

  document.addEventListener('click',function(e){
    var t=e.target;
    if(!t || !t.closest) return;
    if(t.closest('.js-qty__adjust,[data-ms-qty],[data-ms-remove],.cart__remove a,.js-drawer-open-right,[href*="/cart/change"],[name="add"],[data-ms-add]')) soon(450);
  }, true);

  document.addEventListener('ms:cart:refresh', function(){ soon(60); });
  window.addEventListener('pageshow', function(){ last=-1; soon(60); });

  function init(){ watch(); last=-1; pull(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();